const SKILLS = [
  {
    value: ".net",
    label: ".NET"
  },
  {
    value: "3d-modeling",
    label: "3D Modeling"
  },
  {
    value: "acceptance-testing",
    label: "Acceptance Testing"
  },
  {
    value: "account-management",
    label: "Account Management"
  },
  {
    value: "accounting",
    label: "Accounting"
  },
  {
    value: "accounts-payable",
    label: "Accounts Payable"
  },
  {
    value: "accounts-receivable",
    label: "Accounts Receivable"
  },
  {
    value: "acquisitions",
    label: "Acquisitions"
  },
  {
    value: "active-directory",
    label: "Active Directory"
  },
  {
    value: "administrative-assistant",
    label: "Administrative Assistant"
  },
  {
    value: "adobe-acrobat",
    label: "Adobe Acrobat"
  },
  {
    value: "adobe-after-effects",
    label: "Adobe After Effects"
  },
  {
    value: "adobe-creative-suite",
    label: "Adobe Creative Suite"
  },
  {
    value: "adobe-illustrator",
    label: "Adobe Illustrator"
  },
  {
    value: "adobe-indesign",
    label: "Adobe InDesign"
  },
  {
    value: "adobe-photoshop",
    label: "Adobe Photoshop"
  },
  {
    value: "adobe-premiere",
    label: "Adobe Premiere"
  },
  {
    value: "advertising",
    label: "Advertising"
  },
  {
    value: "aerospace",
    label: "Aerospace"
  },
  {
    value: "affiliate-marketing",
    label: "Affiliate Marketing"
  },
  {
    value: "agile",
    label: "Agile"
  },
  {
    value: "agile-methodologies",
    label: "agile methodologies"
  },
  {
    value: "agile-methodology",
    label: "Agile methodology"
  },
  {
    value: "agile-project-management",
    label: "Agile Project Management"
  },
  {
    value: "agile-software-develoment",
    label: "Agile Software Develoment"
  },
  {
    value: "agile/scrum",
    label: "Agile/Scrum"
  },
  {
    value: "ajax",
    label: "AJAX"
  },
  {
    value: "akka",
    label: "Akka"
  },
  {
    value: "algorithms-&-data-structures",
    label: "Algorithms & Data Structures"
  },
  {
    value: "amazon-lambda",
    label: "Amazon Lambda"
  },
  {
    value: "amazon-redshift",
    label: "Amazon Redshift"
  },
  {
    value: "amazon-s3",
    label: "Amazon S3"
  },
  {
    value: "amazon-web-services",
    label: "Amazon Web Services"
  },
  {
    value: "analytical-skills",
    label: "Analytical skills"
  },
  {
    value: "analytics",
    label: "Analytics"
  },
  {
    value: "roid",
    label: "Android"
  },
  {
    value: "roid-design",
    label: "Android Design"
  },
  {
    value: "roid-development",
    label: "Android Development"
  },
  {
    value: "roid-sdk",
    label: "Android SDK"
  },
  {
    value: "roid-studio",
    label: "Android Studio"
  },
  {
    value: "angular",
    label: "Angular"
  },
  {
    value: "angularjs",
    label: "AngularJS"
  },
  {
    value: "animation",
    label: "Animation"
  },
  {
    value: "ansible",
    label: "Ansible"
  },
  {
    value: "ansys",
    label: "Ansys"
  },
  {
    value: "apache",
    label: "Apache"
  },
  {
    value: "apache-ant",
    label: "Apache Ant"
  },
  {
    value: "apache-cassra",
    label: "Apache Cassandra"
  },
  {
    value: "apache-hadoop",
    label: "Apache Hadoop"
  },
  {
    value: "apache-kafka",
    label: "Apache Kafka"
  },
  {
    value: "apache-maven",
    label: "Apache Maven"
  },
  {
    value: "apache-solr",
    label: "Apache Solr"
  },
  {
    value: "apache-spark",
    label: "Apache Spark"
  },
  {
    value: "apache-storm",
    label: "Apache Storm"
  },
  {
    value: "apache-tomcat",
    label: "Apache Tomcat"
  },
  {
    value: "apache-web-server",
    label: "Apache Web Server"
  },
  {
    value: "api",
    label: "API"
  },
  {
    value: "apparel",
    label: "Apparel"
  },
  {
    value: "apple",
    label: "Apple"
  },
  {
    value: "application-development",
    label: "Application Development"
  },
  {
    value: "arabic-language",
    label: "Arabic Language"
  },
  {
    value: "architecture",
    label: "Architecture"
  },
  {
    value: "artificial-intelligence-(ai)",
    label: "Artificial Intelligence (AI)"
  },
  {
    value: "asp.net",
    label: "ASP.NET"
  },
  {
    value: "assembly-language",
    label: "Assembly Language"
  },
  {
    value: "asset-management",
    label: "Asset Management"
  },
  {
    value: "atlassian-jira",
    label: "Atlassian JIRA"
  },
  {
    value: "audit",
    label: "Audit"
  },
  {
    value: "autocad",
    label: "Autocad"
  },
  {
    value: "autodesk",
    label: "AutoDesk"
  },
  {
    value: "autodesk-autocad",
    label: "Autodesk Autocad"
  },
  {
    value: "autodesk-maya",
    label: "Autodesk Maya"
  },
  {
    value: "automation",
    label: "Automation"
  },
  {
    value: "aws",
    label: "AWS"
  },
  {
    value: "aws-cloud-services",
    label: "AWS Cloud Services"
  },
  {
    value: "aws-lambda",
    label: "AWS Lambda"
  },
  {
    value: "aws/ec2/elb/s3/dynamodb",
    label: "AWS/EC2/ELB/S3/DynamoDB"
  },
  {
    value: "axure",
    label: "Axure"
  },
  {
    value: "b2b-marketing",
    label: "B2B Marketing"
  },
  {
    value: "b2b-sales",
    label: "B2B Sales"
  },
  {
    value: "babeljs",
    label: "BabelJS"
  },
  {
    value: "backbone.js",
    label: "Backbone.js"
  },
  {
    value: "backend-development",
    label: "Backend Development"
  },
  {
    value: "bash",
    label: "Bash"
  },
  {
    value: "bash-scripting",
    label: "Bash Scripting"
  },
  {
    value: "bengali-language",
    label: "Bengali language"
  },
  {
    value: "big-data-analytics",
    label: "Big Data Analytics"
  },
  {
    value: "bilingual",
    label: "Bilingual"
  },
  {
    value: "billing",
    label: "Billing"
  },
  {
    value: "bitbucket",
    label: "Bitbucket"
  },
  {
    value: "blogging",
    label: "Blogging"
  },
  {
    value: "bloomberg",
    label: "Bloomberg"
  },
  {
    value: "bluetooth",
    label: "Bluetooth"
  },
  {
    value: "bootstrap",
    label: "Bootstrap"
  },
  {
    value: "br-identity-design",
    label: "Brand and Identity Design"
  },
  {
    value: "br-management",
    label: "Brand Management"
  },
  {
    value: "br-planning",
    label: "Brand Planning"
  },
  {
    value: "bring",
    label: "Branding"
  },
  {
    value: "budgeting",
    label: "Budgeting"
  },
  {
    value: "business-analysis",
    label: "Business Analysis"
  },
  {
    value: "business-analyst",
    label: "Business Analyst"
  },
  {
    value: "business-development",
    label: "Business Development"
  },
  {
    value: "business-development-&-partnerships",
    label: "Business Development & Partnerships"
  },
  {
    value: "business-intelligence",
    label: "Business Intelligence"
  },
  {
    value: "business-management",
    label: "Business Management"
  },
  {
    value: "business-operations",
    label: "Business Operations"
  },
  {
    value: "business-plan",
    label: "Business Plan"
  },
  {
    value: "business-planning",
    label: "Business Planning"
  },
  {
    value: "business-requirement-gathering",
    label: "Business Requirement gathering"
  },
  {
    value: "business-strategy",
    label: "Business Strategy"
  },
  {
    value: "buying",
    label: "Buying"
  },
  {
    value: "c",
    label: "C"
  },
  {
    value: "c-sharp-(c#)",
    label: "C Sharp (C#)"
  },
  {
    value: "c#",
    label: "C#"
  },
  {
    value: "c#.net",
    label: "C#.NET"
  },
  {
    value: "c++",
    label: "C++"
  },
  {
    value: "call-center",
    label: "Call Center"
  },
  {
    value: "capital-markets",
    label: "Capital Markets"
  },
  {
    value: "cascading-style-sheet-(css)",
    label: "Cascading Style Sheet (CSS)"
  },
  {
    value: "cassra",
    label: "Cassandra"
  },
  {
    value: "celery",
    label: "Celery"
  },
  {
    value: "cfo",
    label: "Cfo"
  },
  {
    value: "change-management",
    label: "Change Management"
  },
  {
    value: "channel-development",
    label: "Channel Development"
  },
  {
    value: "chef",
    label: "Chef"
  },
  {
    value: "chemistry",
    label: "Chemistry"
  },
  {
    value: "cisco",
    label: "Cisco"
  },
  {
    value: "citrix",
    label: "Citrix"
  },
  {
    value: "client-onboarding",
    label: "Client Onboarding"
  },
  {
    value: "client-relations",
    label: "Client Relations"
  },
  {
    value: "client-relationship-management",
    label: "Client Relationship Management"
  },
  {
    value: "clojure",
    label: "Clojure"
  },
  {
    value: "closing-deals",
    label: "Closing Deals"
  },
  {
    value: "cloud-computing",
    label: "Cloud Computing"
  },
  {
    value: "clustering",
    label: "Clustering"
  },
  {
    value: "cms",
    label: "CMS"
  },
  {
    value: "coaching",
    label: "Coaching"
  },
  {
    value: "codeigniter",
    label: "Codeigniter"
  },
  {
    value: "coding",
    label: "Coding"
  },
  {
    value: "coffeescript",
    label: "Coffeescript"
  },
  {
    value: "cold-calling",
    label: "Cold Calling"
  },
  {
    value: "communication-skills",
    label: "Communication Skills"
  },
  {
    value: "communications",
    label: "Communications"
  },
  {
    value: "community-building",
    label: "Community Building"
  },
  {
    value: "community-development",
    label: "Community Development"
  },
  {
    value: "community-management",
    label: "Community Management"
  },
  {
    value: "community-outreach",
    label: "Community Outreach"
  },
  {
    value: "compensation",
    label: "compensation"
  },
  {
    value: "compensation-benefits",
    label: "Compensation and Benefits"
  },
  {
    value: "competitive-analysis",
    label: "Competitive Analysis"
  },
  {
    value: "competitor-analysis",
    label: "Competitor Analysis"
  },
  {
    value: "compliance",
    label: "Compliance"
  },
  {
    value: "composer",
    label: "Composer"
  },
  {
    value: "computer-vision",
    label: "Computer Vision"
  },
  {
    value: "configuration-management",
    label: "Configuration Management"
  },
  {
    value: "confluence",
    label: "Confluence"
  },
  {
    value: "construction",
    label: "Construction"
  },
  {
    value: "consultative-sales",
    label: "Consultative Sales"
  },
  {
    value: "consulting",
    label: "Consulting"
  },
  {
    value: "consumer-products",
    label: "Consumer Products"
  },
  {
    value: "content-creative-writing",
    label: "Content and Creative Writing"
  },
  {
    value: "content-creation",
    label: "Content Creation"
  },
  {
    value: "content-management",
    label: "Content Management"
  },
  {
    value: "content-marketing",
    label: "Content Marketing"
  },
  {
    value: "content-strategy",
    label: "Content Strategy"
  },
  {
    value: "content-writing",
    label: "Content Writing"
  },
  {
    value: "continuous-deployment",
    label: "Continuous Deployment"
  },
  {
    value: "continuous-integration",
    label: "Continuous Integration"
  },
  {
    value: "contract-negotiations",
    label: "Contract Negotiations"
  },
  {
    value: "control-systems",
    label: "Control Systems"
  },
  {
    value: "conversion-optimization",
    label: "Conversion Optimization"
  },
  {
    value: "copy-writing-editing",
    label: "Copy Writing and Editing"
  },
  {
    value: "copywriting",
    label: "Copywriting"
  },
  {
    value: "core-java-/-java-se",
    label: "Core Java / Java SE"
  },
  {
    value: "coreldraw",
    label: "CorelDraw"
  },
  {
    value: "corporate-sales-&-business-development-in-b2b",
    label: "Corporate Sales & Business development in B2B"
  },
  {
    value: "creative-direction",
    label: "Creative Direction"
  },
  {
    value: "creative-problem-solving",
    label: "Creative Problem Solving"
  },
  {
    value: "creative-strategy",
    label: "Creative Strategy"
  },
  {
    value: "creative-writing",
    label: "Creative Writing"
  },
  {
    value: "crm",
    label: "CRM"
  },
  {
    value: "crystal-reports",
    label: "Crystal Reports"
  },
  {
    value: "css",
    label: "CSS"
  },
  {
    value: "css3",
    label: "CSS3"
  },
  {
    value: "customer-acquisition",
    label: "Customer Acquisition"
  },
  {
    value: "customer-development",
    label: "Customer Development"
  },
  {
    value: "customer-experience",
    label: "Customer Experience"
  },
  {
    value: "customer-relationship-management",
    label: "Customer Relationship Management"
  },
  {
    value: "customer-service",
    label: "Customer Service"
  },
  {
    value: "customer-success",
    label: "Customer Success"
  },
  {
    value: "cvs",
    label: "CVS"
  },
  {
    value: "d3.js",
    label: "D3.js"
  },
  {
    value: "data-analysis",
    label: "Data Analysis"
  },
  {
    value: "data-entry",
    label: "Data Entry"
  },
  {
    value: "data-management",
    label: "Data Management"
  },
  {
    value: "data-migration",
    label: "Data Migration"
  },
  {
    value: "data-mining",
    label: "Data Mining"
  },
  {
    value: "data-modeling",
    label: "Data Modeling"
  },
  {
    value: "data-processing",
    label: "Data Processing"
  },
  {
    value: "data-science",
    label: "Data Science"
  },
  {
    value: "data-visualization",
    label: "Data Visualization"
  },
  {
    value: "data-warehouse",
    label: "Data Warehouse"
  },
  {
    value: "database-systems-design",
    label: "Database and Systems Design"
  },
  {
    value: "database-management",
    label: "Database Management"
  },
  {
    value: "databases",
    label: "Databases"
  },
  {
    value: "dbms",
    label: "DBMS"
  },
  {
    value: "debugging",
    label: "Debugging"
  },
  {
    value: "deep-learning",
    label: "Deep Learning"
  },
  {
    value: "dem-generation",
    label: "Demand Generation"
  },
  {
    value: "derivatives",
    label: "Derivatives"
  },
  {
    value: "design",
    label: "Design"
  },
  {
    value: "design-management",
    label: "Design Management"
  },
  {
    value: "design-patterns",
    label: "Design Patterns"
  },
  {
    value: "design-research",
    label: "Design Research"
  },
  {
    value: "design-strategy",
    label: "Design Strategy"
  },
  {
    value: "design-thinking",
    label: "Design Thinking"
  },
  {
    value: "dev-ops",
    label: "Dev Ops"
  },
  {
    value: "devops",
    label: "DevOps"
  },
  {
    value: "devops-engineering",
    label: "DevOps Engineering"
  },
  {
    value: "digital-marketing",
    label: "Digital Marketing"
  },
  {
    value: "digital-marketing-strategy",
    label: "Digital Marketing Strategy"
  },
  {
    value: "digital-media",
    label: "Digital Media"
  },
  {
    value: "digital-strategy",
    label: "Digital Strategy"
  },
  {
    value: "disaster-recovery",
    label: "Disaster Recovery"
  },
  {
    value: "display-advertising",
    label: "Display Advertising"
  },
  {
    value: "distributed-systems",
    label: "Distributed Systems"
  },
  {
    value: "distribution",
    label: "Distribution"
  },
  {
    value: "django",
    label: "Django"
  },
  {
    value: "docker",
    label: "Docker"
  },
  {
    value: "documentation",
    label: "Documentation"
  },
  {
    value: "drafting",
    label: "Drafting"
  },
  {
    value: "dreamweaver",
    label: "Dreamweaver"
  },
  {
    value: "drupal",
    label: "Drupal"
  },
  {
    value: "due-diligence",
    label: "Due Diligence"
  },
  {
    value: "dynamodb",
    label: "DynamoDB"
  },
  {
    value: "e-commerce",
    label: "E-Commerce"
  },
  {
    value: "eclipse",
    label: "Eclipse"
  },
  {
    value: "eclipse-ide",
    label: "Eclipse IDE"
  },
  {
    value: "ecommerce",
    label: "Ecommerce"
  },
  {
    value: "economics",
    label: "Economics"
  },
  {
    value: "education",
    label: "Education"
  },
  {
    value: "elasticsearch",
    label: "ElasticSearch"
  },
  {
    value: "electrical-engineering",
    label: "Electrical Engineering"
  },
  {
    value: "electronics",
    label: "Electronics"
  },
  {
    value: "elixir",
    label: "Elixir"
  },
  {
    value: "email",
    label: "Email"
  },
  {
    value: "email-marketing",
    label: "Email Marketing"
  },
  {
    value: "embedded-systems",
    label: "Embedded Systems"
  },
  {
    value: "employee-relations",
    label: "Employee Relations"
  },
  {
    value: "encryption",
    label: "Encryption"
  },
  {
    value: "engineering",
    label: "Engineering"
  },
  {
    value: "engineering-management",
    label: "Engineering Management"
  },
  {
    value: "english",
    label: "English"
  },
  {
    value: "english-language",
    label: "English language"
  },
  {
    value: "enterprise-sales",
    label: "Enterprise Sales"
  },
  {
    value: "enterprise-software",
    label: "Enterprise Software"
  },
  {
    value: "entertainment",
    label: "Entertainment"
  },
  {
    value: "entrepreneurship",
    label: "Entrepreneurship"
  },
  {
    value: "equity",
    label: "Equity"
  },
  {
    value: "erlang",
    label: "Erlang"
  },
  {
    value: "es6",
    label: "Es6"
  },
  {
    value: "etl",
    label: "ETL"
  },
  {
    value: "event-coordination",
    label: "Event Coordination"
  },
  {
    value: "event-management",
    label: "Event Management"
  },
  {
    value: "event-planning",
    label: "Event Planning"
  },
  {
    value: "events",
    label: "Events"
  },
  {
    value: "excellent-communication-skills",
    label: "Excellent Communication Skills"
  },
  {
    value: "executive-assistant",
    label: "Executive Assistant"
  },
  {
    value: "experience-design",
    label: "Experience Design"
  },
  {
    value: "express.js",
    label: "Express.js"
  },
  {
    value: "fabrication",
    label: "Fabrication"
  },
  {
    value: "facebook",
    label: "Facebook"
  },
  {
    value: "facebook-advertising",
    label: "Facebook Advertising"
  },
  {
    value: "facebook-api",
    label: "Facebook API"
  },
  {
    value: "fashion",
    label: "Fashion"
  },
  {
    value: "field-sales",
    label: "Field Sales"
  },
  {
    value: "filing",
    label: "Filing"
  },
  {
    value: "final-cut",
    label: "Final Cut"
  },
  {
    value: "finance",
    label: "Finance"
  },
  {
    value: "financial",
    label: "Financial"
  },
  {
    value: "financial-analysis",
    label: "Financial Analysis"
  },
  {
    value: "financial-management",
    label: "Financial Management"
  },
  {
    value: "financial-modeling",
    label: "Financial Modeling"
  },
  {
    value: "financial-models",
    label: "Financial Models"
  },
  {
    value: "financial-reporting",
    label: "Financial Reporting"
  },
  {
    value: "financial-services",
    label: "Financial Services"
  },
  {
    value: "financial-statements",
    label: "Financial Statements"
  },
  {
    value: "firebase",
    label: "Firebase"
  },
  {
    value: "firewall",
    label: "Firewall"
  },
  {
    value: "firmware",
    label: "Firmware"
  },
  {
    value: "flash",
    label: "Flash"
  },
  {
    value: "focus",
    label: "Focus"
  },
  {
    value: "forecasting",
    label: "Forecasting"
  },
  {
    value: "fraud",
    label: "Fraud"
  },
  {
    value: "french-language",
    label: "French language"
  },
  {
    value: "front-end-development",
    label: "Front-End Development"
  },
  {
    value: "frontend-development",
    label: "Frontend Development"
  },
  {
    value: "full-stack-development",
    label: "Full Stack Development"
  },
  {
    value: "functional-testing",
    label: "Functional Testing"
  },
  {
    value: "funnel-optimization",
    label: "Funnel Optimization"
  },
  {
    value: "game-design",
    label: "Game Design"
  },
  {
    value: "general-ledger",
    label: "General Ledger"
  },
  {
    value: "german-language",
    label: "German Language"
  },
  {
    value: "git",
    label: "Git"
  },
  {
    value: "github",
    label: "Github"
  },
  {
    value: "go",
    label: "Go"
  },
  {
    value: "google-adwords",
    label: "Google Adwords"
  },
  {
    value: "google-adwords-analytics",
    label: "Google Adwords and Analytics"
  },
  {
    value: "google-analytics",
    label: "Google Analytics"
  },
  {
    value: "google-cloud-platform",
    label: "Google Cloud Platform"
  },
  {
    value: "google-maps-api",
    label: "Google Maps API"
  },
  {
    value: "government",
    label: "Government"
  },
  {
    value: "graphic-design",
    label: "Graphic Design"
  },
  {
    value: "groovy",
    label: "Groovy"
  },
  {
    value: "growth-hacking",
    label: "Growth Hacking"
  },
  {
    value: "grunt",
    label: "Grunt"
  },
  {
    value: "gulp",
    label: "Gulp"
  },
  {
    value: "hadoop",
    label: "Hadoop"
  },
  {
    value: "hadoop/hive/spark/scala/mllib",
    label: "Hadoop/Hive/Spark/Scala/MLlib"
  },
  {
    value: "hardware-engineering",
    label: "Hardware Engineering"
  },
  {
    value: "hbase",
    label: "Hbase"
  },
  {
    value: "help-desk",
    label: "Help Desk"
  },
  {
    value: "heroku",
    label: "Heroku"
  },
  {
    value: "hibernate",
    label: "Hibernate"
  },
  {
    value: "hindi-language",
    label: "Hindi Language"
  },
  {
    value: "hiring",
    label: "Hiring"
  },
  {
    value: "hive",
    label: "Hive"
  },
  {
    value: "hp",
    label: "HP"
  },
  {
    value: "hr",
    label: "HR"
  },
  {
    value: "hr-management",
    label: "HR Management"
  },
  {
    value: "html",
    label: "HTML"
  },
  {
    value: "html/css/javascript",
    label: "HTML/CSS/Javascript"
  },
  {
    value: "html/css/php/mysql",
    label: "HTML/CSS/PHP/MYSQL"
  },
  {
    value: "html+css",
    label: "HTML+CSS"
  },
  {
    value: "html5",
    label: "HTML5"
  },
  {
    value: "html5-&-css3",
    label: "HTML5 & CSS3"
  },
  {
    value: "https",
    label: "HTTPS"
  },
  {
    value: "hubspot",
    label: "HubSpot"
  },
  {
    value: "human-resources",
    label: "Human Resources"
  },
  {
    value: "ibm",
    label: "IBM"
  },
  {
    value: "ibm-db2",
    label: "IBM DB2"
  },
  {
    value: "ibm-websphere",
    label: "IBM Websphere"
  },
  {
    value: "icon-design",
    label: "Icon Design"
  },
  {
    value: "illustration",
    label: "Illustration"
  },
  {
    value: "image-processing",
    label: "Image Processing"
  },
  {
    value: "imaging",
    label: "Imaging"
  },
  {
    value: "inbound-outbound-sales",
    label: "Inbound and Outbound Sales"
  },
  {
    value: "inbound-marketing",
    label: "Inbound Marketing"
  },
  {
    value: "industrial-design",
    label: "Industrial Design"
  },
  {
    value: "influencer-marketing",
    label: "Influencer Marketing"
  },
  {
    value: "informatica",
    label: "Informatica"
  },
  {
    value: "information-security",
    label: "Information Security"
  },
  {
    value: "information-technology",
    label: "Information Technology"
  },
  {
    value: "infrastructure",
    label: "Infrastructure"
  },
  {
    value: "inside-sales",
    label: "Inside Sales"
  },
  {
    value: "instagram-marketing",
    label: "Instagram Marketing"
  },
  {
    value: "insurance",
    label: "Insurance"
  },
  {
    value: "integration-testing",
    label: "Integration Testing"
  },
  {
    value: "integrity",
    label: "Integrity"
  },
  {
    value: "interaction-design",
    label: "Interaction Design"
  },
  {
    value: "interactive-design",
    label: "Interactive Design"
  },
  {
    value: "interface-design",
    label: "Interface Design"
  },
  {
    value: "internal-audit",
    label: "Internal Audit"
  },
  {
    value: "international-sales",
    label: "International Sales"
  },
  {
    value: "internet",
    label: "Internet"
  },
  {
    value: "internet-marketing",
    label: "Internet Marketing"
  },
  {
    value: "inventory",
    label: "Inventory"
  },
  {
    value: "inventory-control",
    label: "Inventory control"
  },
  {
    value: "inventory-management",
    label: "Inventory Management"
  },
  {
    value: "investment-banking",
    label: "Investment Banking"
  },
  {
    value: "investor-relations",
    label: "Investor Relations"
  },
  {
    value: "invision",
    label: "Invision"
  },
  {
    value: "invision-prototyping",
    label: "InVision Prototyping"
  },
  {
    value: "ios",
    label: "iOS"
  },
  {
    value: "ios-design",
    label: "iOS Design"
  },
  {
    value: "ios-development",
    label: "iOS Development"
  },
  {
    value: "ios/roid-design",
    label: "iOS/Android Design"
  },
  {
    value: "iso",
    label: "ISO"
  },
  {
    value: "it-management",
    label: "IT Management"
  },
  {
    value: "itil",
    label: "ITIL"
  },
  {
    value: "japanese-language",
    label: "Japanese Language"
  },
  {
    value: "java",
    label: "Java"
  },
  {
    value: "java-j2ee",
    label: "Java J2EE"
  },
  {
    value: "java-server-pages",
    label: "Java Server Pages"
  },
  {
    value: "javascript",
    label: "Javascript"
  },
  {
    value: "javascript-frameworks",
    label: "Javascript Frameworks"
  },
  {
    value: "jboss",
    label: "JBoss"
  },
  {
    value: "jdbc",
    label: "JDBC"
  },
  {
    value: "jenkins",
    label: "Jenkins"
  },
  {
    value: "jira",
    label: "Jira"
  },
  {
    value: "jmeter",
    label: "JMeter"
  },
  {
    value: "journalism",
    label: "Journalism"
  },
  {
    value: "jquery",
    label: "jQuery"
  },
  {
    value: "jquery-mobile",
    label: "jQuery Mobile"
  },
  {
    value: "json",
    label: "JSON"
  },
  {
    value: "json-/-xml",
    label: "JSON / XML"
  },
  {
    value: "json-/-xml-/-html-/-javascript-/-jquery",
    label: "JSON / XML / HTML / Javascript / JQuery"
  },
  {
    value: "junit",
    label: "JUNIT"
  },
  {
    value: "jvm",
    label: "JVM"
  },
  {
    value: "kafka",
    label: "Kafka"
  },
  {
    value: "kanban",
    label: "Kanban"
  },
  {
    value: "kannada-language",
    label: "Kannada Language"
  },
  {
    value: "kotlin",
    label: "Kotlin"
  },
  {
    value: "kubernetes",
    label: "Kubernetes"
  },
  {
    value: "ling-page-optimization",
    label: "Landing Page Optimization"
  },
  {
    value: "laravel",
    label: "Laravel"
  },
  {
    value: "layout",
    label: "Layout"
  },
  {
    value: "lead-generation",
    label: "Lead Generation"
  },
  {
    value: "leadership",
    label: "Leadership"
  },
  {
    value: "leadership-development",
    label: "Leadership Development"
  },
  {
    value: "legal",
    label: "Legal"
  },
  {
    value: "less",
    label: "LESS"
  },
  {
    value: "less-css",
    label: "Less CSS"
  },
  {
    value: "licensing",
    label: "Licensing"
  },
  {
    value: "linkedin-marketing",
    label: "Linkedin Marketing"
  },
  {
    value: "linux",
    label: "Linux"
  },
  {
    value: "linux-system-administration",
    label: "Linux System Administration"
  },
  {
    value: "litigation",
    label: "litigation"
  },
  {
    value: "logistics",
    label: "Logistics"
  },
  {
    value: "logo-design",
    label: "Logo Design"
  },
  {
    value: "lotus-notes",
    label: "Lotus Notes"
  },
  {
    value: "mac-os-x",
    label: "Mac OS X"
  },
  {
    value: "machine-learning",
    label: "Machine Learning"
  },
  {
    value: "magento",
    label: "MAGENTO"
  },
  {
    value: "mailchimp",
    label: "Mailchimp"
  },
  {
    value: "management",
    label: "Management"
  },
  {
    value: "manual-testing",
    label: "Manual Testing"
  },
  {
    value: "manufacturing",
    label: "Manufacturing"
  },
  {
    value: "marathi-language",
    label: "marathi language"
  },
  {
    value: "market-research",
    label: "Market Research"
  },
  {
    value: "marketing",
    label: "Marketing"
  },
  {
    value: "marketing-automation",
    label: "Marketing Automation"
  },
  {
    value: "marketing-communications",
    label: "Marketing Communications"
  },
  {
    value: "marketing-management",
    label: "Marketing Management"
  },
  {
    value: "marketing-strategy",
    label: "Marketing Strategy"
  },
  {
    value: "matlab",
    label: "Matlab"
  },
  {
    value: "maven",
    label: "Maven"
  },
  {
    value: "mba",
    label: "MBA"
  },
  {
    value: "mechanical-design",
    label: "Mechanical Design"
  },
  {
    value: "mechanical-engineering",
    label: "Mechanical Engineering"
  },
  {
    value: "media-relations",
    label: "Media Relations"
  },
  {
    value: "medical",
    label: "Medical"
  },
  {
    value: "memcached",
    label: "Memcached"
  },
  {
    value: "merchising",
    label: "Merchandising"
  },
  {
    value: "messaging",
    label: "Messaging"
  },
  {
    value: "metrics",
    label: "Metrics"
  },
  {
    value: "microsoft",
    label: "Microsoft"
  },
  {
    value: "microsoft-.net",
    label: "Microsoft .NET"
  },
  {
    value: "microsoft-access",
    label: "Microsoft Access"
  },
  {
    value: "microsoft-active-directory",
    label: "Microsoft Active Directory"
  },
  {
    value: "microsoft-azure",
    label: "Microsoft Azure"
  },
  {
    value: "microsoft-excel",
    label: "Microsoft Excel"
  },
  {
    value: "microsoft-exchange",
    label: "Microsoft Exchange"
  },
  {
    value: "microsoft-office",
    label: "Microsoft Office"
  },
  {
    value: "microsoft-outlook",
    label: "Microsoft Outlook"
  },
  {
    value: "microsoft-powerpoint",
    label: "Microsoft PowerPoint"
  },
  {
    value: "microsoft-project",
    label: "Microsoft Project"
  },
  {
    value: "microsoft-sql-server",
    label: "Microsoft SQL Server"
  },
  {
    value: "microsoft-visio",
    label: "Microsoft Visio"
  },
  {
    value: "microsoft-visual-basic",
    label: "Microsoft Visual Basic"
  },
  {
    value: "microsoft-visual-studio",
    label: "Microsoft Visual Studio"
  },
  {
    value: "microsoft-windows",
    label: "Microsoft Windows"
  },
  {
    value: "microsoft-windows-xp-7-8-8.1-10",
    label: "Microsoft Windows XP 7 8 8.1 10"
  },
  {
    value: "microsoft-word",
    label: "Microsoft Word"
  },
  {
    value: "middleware",
    label: "Middleware"
  },
  {
    value: "mining",
    label: "Mining"
  },
  {
    value: "mobile",
    label: "Mobile"
  },
  {
    value: "mobile-advertising",
    label: "Mobile Advertising"
  },
  {
    value: "mobile-application-design",
    label: "Mobile Application Design"
  },
  {
    value: "mobile-application-development",
    label: "Mobile Application Development"
  },
  {
    value: "mobile-design",
    label: "Mobile Design"
  },
  {
    value: "mobile-development",
    label: "Mobile Development"
  },
  {
    value: "mobile-ui-design",
    label: "Mobile UI Design"
  },
  {
    value: "mobile-ui-interaction",
    label: "Mobile UI Interaction"
  },
  {
    value: "mobile-user-experience",
    label: "Mobile User Experience"
  },
  {
    value: "mockups",
    label: "Mockups"
  },
  {
    value: "mongodb",
    label: "MongoDB"
  },
  {
    value: "monitoring",
    label: "Monitoring"
  },
  {
    value: "motion-graphics",
    label: "Motion Graphics"
  },
  {
    value: "ms-office",
    label: "MS Office"
  },
  {
    value: "ms-project",
    label: "Ms Project"
  },
  {
    value: "ms-sql-server",
    label: "MS SQL Server"
  },
  {
    value: "multimedia",
    label: "Multimedia"
  },
  {
    value: "mvc",
    label: "Mvc"
  },
  {
    value: "mysql",
    label: "MySQL"
  },
  {
    value: "natural-language-processing",
    label: "Natural Language Processing"
  },
  {
    value: "negotiation",
    label: "Negotiation"
  },
  {
    value: "negotiation-skills",
    label: "Negotiation Skills"
  },
  {
    value: "neo4j",
    label: "Neo4J"
  },
  {
    value: "netbeans",
    label: "Netbeans"
  },
  {
    value: "network-security",
    label: "Network Security"
  },
  {
    value: "networking",
    label: "Networking"
  },
  {
    value: "neural-networks",
    label: "Neural Networks"
  },
  {
    value: "new-business-development",
    label: "New Business Development"
  },
  {
    value: "nginx",
    label: "Nginx"
  },
  {
    value: "node.js",
    label: "Node.js"
  },
  {
    value: "nodejs",
    label: "NodeJS"
  },
  {
    value: "nosql",
    label: "noSQL"
  },
  {
    value: "numpy",
    label: "Numpy"
  },
  {
    value: "numpy/scipy/pas/scikit-learn",
    label: "Numpy/Scipy/Pandas/Scikit-learn"
  },
  {
    value: "object-oriented-programming",
    label: "Object Oriented Programming"
  },
  {
    value: "objective-c",
    label: "Objective-C"
  },
  {
    value: "office-administration",
    label: "Office Administration"
  },
  {
    value: "office-management",
    label: "Office Management"
  },
  {
    value: "online-marketing",
    label: "Online Marketing"
  },
  {
    value: "online-marketing-copywriting",
    label: "Online Marketing and Copywriting"
  },
  {
    value: "opencv",
    label: "OpenCV"
  },
  {
    value: "opengl",
    label: "OpenGL"
  },
  {
    value: "operating-systems",
    label: "Operating Systems"
  },
  {
    value: "operations",
    label: "Operations"
  },
  {
    value: "operations-management",
    label: "Operations Management"
  },
  {
    value: "oracle",
    label: "Oracle"
  },
  {
    value: "oracle-10g",
    label: "Oracle 10g"
  },
  {
    value: "oracle-11g",
    label: "Oracle 11g"
  },
  {
    value: "organization",
    label: "Organization"
  },
  {
    value: "origami",
    label: "Origami"
  },
  {
    value: "outsourcing",
    label: "Outsourcing"
  },
  {
    value: "p&l",
    label: "P&L"
  },
  {
    value: "packaging",
    label: "Packaging"
  },
  {
    value: "paid-search-advertising",
    label: "Paid Search Advertising"
  },
  {
    value: "payroll",
    label: "Payroll"
  },
  {
    value: "pc",
    label: "PC"
  },
  {
    value: "people-management",
    label: "People Management"
  },
  {
    value: "peoplesoft",
    label: "PeopleSoft"
  },
  {
    value: "performance-testing",
    label: "Performance Testing"
  },
  {
    value: "perl",
    label: "Perl"
  },
  {
    value: "pharmaceutical",
    label: "Pharmaceutical"
  },
  {
    value: "phone-skills",
    label: "Phone Skills"
  },
  {
    value: "phonegap/cordova",
    label: "PhoneGap/Cordova"
  },
  {
    value: "photography",
    label: "Photography"
  },
  {
    value: "php",
    label: "PHP"
  },
  {
    value: "pig",
    label: "Pig"
  },
  {
    value: "planning",
    label: "Planning"
  },
  {
    value: "pmp",
    label: "PMP"
  },
  {
    value: "policies-procedures",
    label: "Policies and Procedures"
  },
  {
    value: "portfolio-management",
    label: "Portfolio Management"
  },
  {
    value: "pos",
    label: "POS"
  },
  {
    value: "postgresql",
    label: "PostgreSQL"
  },
  {
    value: "ppc",
    label: "PPC"
  },
  {
    value: "pr",
    label: "PR"
  },
  {
    value: "predictive-analytics",
    label: "Predictive Analytics"
  },
  {
    value: "presentation-skills",
    label: "Presentation Skills"
  },
  {
    value: "press-release-writing",
    label: "Press Release Writing"
  },
  {
    value: "pricing",
    label: "Pricing"
  },
  {
    value: "print-design",
    label: "Print Design"
  },
  {
    value: "private-equity",
    label: "Private Equity"
  },
  {
    value: "problem-solving",
    label: "Problem Solving"
  },
  {
    value: "problem-solving-skills",
    label: "Problem Solving Skills"
  },
  {
    value: "process-improvement",
    label: "Process Improvement"
  },
  {
    value: "process-improvements",
    label: "process improvements"
  },
  {
    value: "process-management",
    label: "Process Management"
  },
  {
    value: "procurement",
    label: "Procurement"
  },
  {
    value: "product",
    label: "Product"
  },
  {
    value: "product-design",
    label: "Product Design"
  },
  {
    value: "product-development",
    label: "Product Development"
  },
  {
    value: "product-evangelism",
    label: "Product Evangelism"
  },
  {
    value: "product-launch",
    label: "Product Launch"
  },
  {
    value: "product-management",
    label: "Product Management"
  },
  {
    value: "product-marketing",
    label: "Product Marketing"
  },
  {
    value: "product-strategy",
    label: "Product Strategy"
  },
  {
    value: "professional-services",
    label: "Professional Services"
  },
  {
    value: "program-management",
    label: "Program Management"
  },
  {
    value: "program-manager",
    label: "Program Manager"
  },
  {
    value: "programming",
    label: "Programming"
  },
  {
    value: "programming-languages",
    label: "Programming Languages"
  },
  {
    value: "programming:-3p-apis-&-libraries",
    label: "Programming: 3P APIs & Libraries"
  },
  {
    value: "project-coordinator",
    label: "Project Coordinator"
  },
  {
    value: "project-leader",
    label: "Project Leader"
  },
  {
    value: "project-management",
    label: "Project Management"
  },
  {
    value: "project-manager",
    label: "Project Manager"
  },
  {
    value: "proofreading",
    label: "Proofreading"
  },
  {
    value: "prospecting",
    label: "Prospecting"
  },
  {
    value: "prospecting-cold-calling",
    label: "Prospecting and Cold Calling"
  },
  {
    value: "prototyping",
    label: "Prototyping"
  },
  {
    value: "public-relations",
    label: "Public Relations"
  },
  {
    value: "public-speaking",
    label: "Public Speaking"
  },
  {
    value: "public-speaking-presentations",
    label: "Public Speaking and Presentations"
  },
  {
    value: "publications",
    label: "Publications"
  },
  {
    value: "publishing",
    label: "Publishing"
  },
  {
    value: "puppet",
    label: "Puppet"
  },
  {
    value: "purchasing",
    label: "Purchasing"
  },
  {
    value: "python",
    label: "Python"
  },
  {
    value: "qa",
    label: "QA"
  },
  {
    value: "quality",
    label: "Quality"
  },
  {
    value: "quality-assurance",
    label: "Quality Assurance"
  },
  {
    value: "quality-control",
    label: "Quality Control"
  },
  {
    value: "quality-management",
    label: "Quality Management"
  },
  {
    value: "quick-books",
    label: "Quick Books"
  },
  {
    value: "quickbooks",
    label: "Quickbooks"
  },
  {
    value: "r",
    label: "R"
  },
  {
    value: "rabbitmq",
    label: "Rabbitmq"
  },
  {
    value: "rapid-prototyping",
    label: "Rapid Prototyping"
  },
  {
    value: "rdbms",
    label: "RDBMS"
  },
  {
    value: "react-native",
    label: "React Native"
  },
  {
    value: "react.js",
    label: "React.js"
  },
  {
    value: "reactjs",
    label: "ReactJS"
  },
  {
    value: "real-estate",
    label: "Real Estate"
  },
  {
    value: "reconciliations",
    label: "Reconciliations"
  },
  {
    value: "recruiter",
    label: "Recruiter"
  },
  {
    value: "recruiting",
    label: "Recruiting"
  },
  {
    value: "recruiting/onboarding/training-new-hires",
    label: "Recruiting/Onboarding/Training New Hires"
  },
  {
    value: "recruiting/talent-acquisition/-hr-reporting",
    label: "Recruiting/Talent Acquisition/ HR Reporting"
  },
  {
    value: "recruitment",
    label: "Recruitment"
  },
  {
    value: "redhat",
    label: "Redhat"
  },
  {
    value: "redis",
    label: "Redis"
  },
  {
    value: "redux",
    label: "Redux"
  },
  {
    value: "regression-testing",
    label: "Regression Testing"
  },
  {
    value: "relational-databases",
    label: "Relational Databases"
  },
  {
    value: "relationship-building",
    label: "Relationship Building"
  },
  {
    value: "reliability",
    label: "Reliability"
  },
  {
    value: "requirements-analysis",
    label: "Requirements Analysis"
  },
  {
    value: "requirements-gathering",
    label: "Requirements Gathering"
  },
  {
    value: "research",
    label: "Research"
  },
  {
    value: "research-development",
    label: "Research and Development"
  },
  {
    value: "responsive-design",
    label: "Responsive Design"
  },
  {
    value: "rest",
    label: "REST"
  },
  {
    value: "rest-apis",
    label: "REST APIs"
  },
  {
    value: "retail",
    label: "Retail"
  },
  {
    value: "retail-sales",
    label: "Retail Sales"
  },
  {
    value: "retention",
    label: "Retention"
  },
  {
    value: "revenue-growth",
    label: "Revenue Growth"
  },
  {
    value: "risk-analysis",
    label: "Risk Analysis"
  },
  {
    value: "risk-assessment",
    label: "Risk Assessment"
  },
  {
    value: "risk-management",
    label: "Risk Management"
  },
  {
    value: "robotics",
    label: "Robotics"
  },
  {
    value: "root-cause-analysis",
    label: "Root Cause Analysis"
  },
  {
    value: "routers",
    label: "Routers"
  },
  {
    value: "rspec",
    label: "Rspec"
  },
  {
    value: "ruby",
    label: "Ruby"
  },
  {
    value: "ruby-on-rails",
    label: "Ruby on Rails"
  },
  {
    value: "russian-language",
    label: "Russian language"
  },
  {
    value: "saas",
    label: "SaaS"
  },
  {
    value: "saas-sales",
    label: "SaaS Sales"
  },
  {
    value: "sales",
    label: "Sales"
  },
  {
    value: "sales-marketing",
    label: "Sales and Marketing"
  },
  {
    value: "sales-development",
    label: "Sales Development"
  },
  {
    value: "sales-engineering",
    label: "Sales Engineering"
  },
  {
    value: "sales-management",
    label: "Sales Management"
  },
  {
    value: "sales-operations",
    label: "Sales Operations"
  },
  {
    value: "sales-strategy-management",
    label: "Sales Strategy and Management"
  },
  {
    value: "sales-support",
    label: "Sales Support"
  },
  {
    value: "sales-training",
    label: "Sales Training"
  },
  {
    value: "sales/marketing-strategic-partnerships",
    label: "Sales/Marketing and Strategic Partnerships"
  },
  {
    value: "salesforce",
    label: "Salesforce"
  },
  {
    value: "salesforce-developer",
    label: "Salesforce Developer"
  },
  {
    value: "salesforce.com",
    label: "SalesForce.com"
  },
  {
    value: "sap",
    label: "SAP"
  },
  {
    value: "sas",
    label: "SAS"
  },
  {
    value: "scala",
    label: "Scala"
  },
  {
    value: "scheduling",
    label: "Scheduling"
  },
  {
    value: "science",
    label: "Science"
  },
  {
    value: "scripting-languages",
    label: "Scripting Languages"
  },
  {
    value: "scrum",
    label: "SCRUM"
  },
  {
    value: "scrum-master",
    label: "Scrum Master"
  },
  {
    value: "scss-/-sass",
    label: "SCSS / SASS"
  },
  {
    value: "sdk",
    label: "SDK"
  },
  {
    value: "sdlc",
    label: "SDLC"
  },
  {
    value: "search-engine-marketing-(sem)",
    label: "Search Engine Marketing (SEM)"
  },
  {
    value: "search-engine-optimization",
    label: "Search Engine Optimization"
  },
  {
    value: "securities",
    label: "Securities"
  },
  {
    value: "security",
    label: "Security"
  },
  {
    value: "selenium",
    label: "Selenium"
  },
  {
    value: "selenium-webdriver",
    label: "Selenium WebDriver"
  },
  {
    value: "seo",
    label: "SEO"
  },
  {
    value: "seo-marketing-services",
    label: "SEO and Marketing Services"
  },
  {
    value: "seo-website-analytics",
    label: "SEO and Website Analytics"
  },
  {
    value: "seo/sem",
    label: "SEO/SEM"
  },
  {
    value: "servers",
    label: "Servers"
  },
  {
    value: "services",
    label: "Services"
  },
  {
    value: "servlets",
    label: "Servlets"
  },
  {
    value: "sharepoint",
    label: "SharePoint"
  },
  {
    value: "shell-scripting",
    label: "Shell Scripting"
  },
  {
    value: "shopify",
    label: "Shopify"
  },
  {
    value: "sketch",
    label: "Sketch"
  },
  {
    value: "sketching",
    label: "Sketching"
  },
  {
    value: "social-media",
    label: "Social Media"
  },
  {
    value: "social-media-management",
    label: "Social Media Management"
  },
  {
    value: "social-media-marketing",
    label: "Social Media Marketing"
  },
  {
    value: "social-media-strategy",
    label: "Social Media Strategy"
  },
  {
    value: "social-networking",
    label: "Social Networking"
  },
  {
    value: "socket.io",
    label: "Socket.io"
  },
  {
    value: "software",
    label: "Software"
  },
  {
    value: "software-architecture",
    label: "Software Architecture"
  },
  {
    value: "software-design",
    label: "Software Design"
  },
  {
    value: "software-development",
    label: "Software Development"
  },
  {
    value: "software-engineering",
    label: "Software Engineering"
  },
  {
    value: "software-sales",
    label: "Software Sales"
  },
  {
    value: "software-testing",
    label: "Software Testing"
  },
  {
    value: "solidworks",
    label: "Solidworks"
  },
  {
    value: "solutions-selling",
    label: "Solutions Selling"
  },
  {
    value: "sourcing",
    label: "Sourcing"
  },
  {
    value: "spanish-language",
    label: "Spanish language"
  },
  {
    value: "spark",
    label: "Spark"
  },
  {
    value: "sports",
    label: "Sports"
  },
  {
    value: "spring",
    label: "Spring"
  },
  {
    value: "spss",
    label: "SPSS"
  },
  {
    value: "sql",
    label: "SQL"
  },
  {
    value: "sql-server",
    label: "SQL Server"
  },
  {
    value: "sql/mysql/postgresql",
    label: "SQL/MySQL/PostgreSQL"
  },
  {
    value: "sqlite",
    label: "SQLite"
  },
  {
    value: "start-ups",
    label: "Start-Ups"
  },
  {
    value: "startups",
    label: "Startups"
  },
  {
    value: "statistical-analysis",
    label: "Statistical Analysis"
  },
  {
    value: "statistics",
    label: "Statistics"
  },
  {
    value: "storage-area-networks",
    label: "Storage Area Networks"
  },
  {
    value: "stored-procedures",
    label: "Stored procedures"
  },
  {
    value: "strategic-partnerships",
    label: "Strategic Partnerships"
  },
  {
    value: "strategic-planning",
    label: "Strategic Planning"
  },
  {
    value: "strong-work-ethic",
    label: "Strong Work Ethic"
  },
  {
    value: "struts",
    label: "Struts"
  },
  {
    value: "supply-chain-management",
    label: "Supply Chain Management"
  },
  {
    value: "support",
    label: "Support"
  },
  {
    value: "svn",
    label: "Svn"
  },
  {
    value: "swedish",
    label: "Swedish"
  },
  {
    value: "swift",
    label: "Swift"
  },
  {
    value: "symfony",
    label: "Symfony"
  },
  {
    value: "system-administration",
    label: "System Administration"
  },
  {
    value: "system-design",
    label: "System Design"
  },
  {
    value: "system-integration",
    label: "System Integration"
  },
  {
    value: "system-testing",
    label: "System testing"
  },
  {
    value: "systems-administration",
    label: "Systems Administration"
  },
  {
    value: "tableau",
    label: "Tableau"
  },
  {
    value: "tableau-software",
    label: "Tableau Software"
  },
  {
    value: "talent-acquisition",
    label: "Talent Acquisition"
  },
  {
    value: "talent-management",
    label: "Talent Management"
  },
  {
    value: "tamil-language",
    label: "Tamil language"
  },
  {
    value: "tcp/ip",
    label: "TCP/IP"
  },
  {
    value: "tdd",
    label: "TDD"
  },
  {
    value: "team-building",
    label: "Team Building"
  },
  {
    value: "team-lead",
    label: "Team Lead"
  },
  {
    value: "team-player",
    label: "Team Player"
  },
  {
    value: "teamwork",
    label: "Teamwork"
  },
  {
    value: "technical-&-customer-support",
    label: "Technical & Customer Support"
  },
  {
    value: "technical-documentation",
    label: "Technical documentation"
  },
  {
    value: "technical-leadership",
    label: "Technical Leadership"
  },
  {
    value: "technical-recruiting",
    label: "Technical Recruiting"
  },
  {
    value: "technical-sales",
    label: "Technical Sales"
  },
  {
    value: "technical-support",
    label: "Technical Support"
  },
  {
    value: "technical-writing",
    label: "Technical Writing"
  },
  {
    value: "technology",
    label: "Technology"
  },
  {
    value: "telecommunications",
    label: "Telecommunications"
  },
  {
    value: "telemarketing",
    label: "Telemarketing"
  },
  {
    value: "tensorflow",
    label: "TensorFlow"
  },
  {
    value: "terraform",
    label: "Terraform"
  },
  {
    value: "test",
    label: "Test"
  },
  {
    value: "test-automation",
    label: "Test Automation"
  },
  {
    value: "test-cases",
    label: "Test Cases"
  },
  {
    value: "test-plans",
    label: "Test Plans"
  },
  {
    value: "test-scripts",
    label: "Test Scripts"
  },
  {
    value: "tfs",
    label: "TFS"
  },
  {
    value: "time-management",
    label: "Time Management"
  },
  {
    value: "toad",
    label: "Toad"
  },
  {
    value: "tourism",
    label: "Tourism"
  },
  {
    value: "training",
    label: "Training"
  },
  {
    value: "training-&-development",
    label: "Training & Development"
  },
  {
    value: "transportation",
    label: "Transportation"
  },
  {
    value: "travel",
    label: "Travel"
  },
  {
    value: "trello",
    label: "Trello"
  },
  {
    value: "troubleshooting",
    label: "Troubleshooting"
  },
  {
    value: "twitter",
    label: "Twitter"
  },
  {
    value: "twitter-bootstrap",
    label: "Twitter Bootstrap"
  },
  {
    value: "twitter-marketing",
    label: "Twitter Marketing"
  },
  {
    value: "typescript",
    label: "TypeScript"
  },
  {
    value: "typing",
    label: "Typing"
  },
  {
    value: "typography",
    label: "Typography"
  },
  {
    value: "ubuntu",
    label: "Ubuntu"
  },
  {
    value: "ui-design",
    label: "UI Design"
  },
  {
    value: "ui/ux-design",
    label: "UI/UX Design"
  },
  {
    value: "underwriting",
    label: "Underwriting"
  },
  {
    value: "unit-testing",
    label: "Unit Testing"
  },
  {
    value: "unity",
    label: "Unity"
  },
  {
    value: "unity3d",
    label: "Unity3D"
  },
  {
    value: "unix",
    label: "Unix"
  },
  {
    value: "unix-shell-scripting",
    label: "Unix Shell Scripting"
  },
  {
    value: "unreal-engine-4",
    label: "Unreal Engine 4"
  },
  {
    value: "usability-testing",
    label: "Usability Testing"
  },
  {
    value: "use-cases",
    label: "Use Cases"
  },
  {
    value: "user-acceptance-testing",
    label: "User Acceptance Testing"
  },
  {
    value: "user-acquisition",
    label: "User Acquisition"
  },
  {
    value: "user-experience-design",
    label: "User Experience Design"
  },
  {
    value: "user-experience-strategy",
    label: "User Experience Strategy"
  },
  {
    value: "user-interaction-design",
    label: "User Interaction Design"
  },
  {
    value: "user-interface",
    label: "User Interface"
  },
  {
    value: "user-interface-design",
    label: "User Interface Design"
  },
  {
    value: "user-research",
    label: "User Research"
  },
  {
    value: "user-centered-design",
    label: "User-Centered Design"
  },
  {
    value: "utilities",
    label: "Utilities"
  },
  {
    value: "ux-design",
    label: "UX Design"
  },
  {
    value: "ux-research",
    label: "UX Research"
  },
  {
    value: "vagrant",
    label: "Vagrant"
  },
  {
    value: "vendor-management",
    label: "Vendor Management"
  },
  {
    value: "venture-capital",
    label: "Venture Capital"
  },
  {
    value: "verbal-communication",
    label: "Verbal Communication"
  },
  {
    value: "verilog",
    label: "Verilog"
  },
  {
    value: "version-control",
    label: "Version Control"
  },
  {
    value: "vhdl",
    label: "VHDL"
  },
  {
    value: "video",
    label: "Video"
  },
  {
    value: "video-advertising",
    label: "Video Advertising"
  },
  {
    value: "video-editing",
    label: "Video Editing"
  },
  {
    value: "video-production",
    label: "Video Production"
  },
  {
    value: "viral-marketing",
    label: "Viral Marketing"
  },
  {
    value: "virtualization",
    label: "Virtualization"
  },
  {
    value: "visio",
    label: "Visio"
  },
  {
    value: "visual-basic",
    label: "Visual Basic"
  },
  {
    value: "visual-design",
    label: "Visual Design"
  },
  {
    value: "vmware",
    label: "VMware"
  },
  {
    value: "voice",
    label: "VOICE"
  },
  {
    value: "vue.js",
    label: "Vue.Js"
  },
  {
    value: "wealth-management",
    label: "Wealth Management"
  },
  {
    value: "web",
    label: "WEB"
  },
  {
    value: "web-analytics",
    label: "Web Analytics"
  },
  {
    value: "web-application-design",
    label: "Web Application Design"
  },
  {
    value: "web-application-frameworks",
    label: "Web Application Frameworks"
  },
  {
    value: "web-applications",
    label: "Web Applications"
  },
  {
    value: "web-content-writer",
    label: "Web Content Writer"
  },
  {
    value: "web-design",
    label: "Web Design"
  },
  {
    value: "web-development",
    label: "Web Development"
  },
  {
    value: "web-services",
    label: "Web Services"
  },
  {
    value: "web-technologies",
    label: "Web Technologies"
  },
  {
    value: "webgl",
    label: "WebGL"
  },
  {
    value: "webpack",
    label: "Webpack"
  },
  {
    value: "webrtc",
    label: "WebRTC"
  },
  {
    value: "websockets",
    label: "Websockets"
  },
  {
    value: "wholesale",
    label: "Wholesale"
  },
  {
    value: "windows-7",
    label: "Windows 7"
  },
  {
    value: "windows-azure",
    label: "Windows Azure"
  },
  {
    value: "windows-xp",
    label: "Windows XP"
  },
  {
    value: "wireframing",
    label: "Wireframing"
  },
  {
    value: "wireless",
    label: "Wireless"
  },
  {
    value: "wireshark",
    label: "Wireshark"
  },
  {
    value: "wordpress",
    label: "Wordpress"
  },
  {
    value: "writing",
    label: "Writing"
  },
  {
    value: "written-communication",
    label: "Written communication"
  },
  {
    value: "xamarin",
    label: "Xamarin"
  },
  {
    value: "xcode",
    label: "Xcode"
  },
  {
    value: "xml",
    label: "XML"
  },
  {
    value: "zendesk",
    label: "ZenDesk"
  },
  {
    value: "zepto",
    label: "Zepto"
  }
];

export default SKILLS;
